<template>
  <span v-html="formatValue(Number(animatedValue))"></span>
</template>

<script>
// https://github.com/Leocardoso94/animated-number-vue
// Fork: https://github.com/NikitaKA/animated-number-vue
import anime from 'animejs';

export default {
  props: {
    value: {
      type: [Number, String],
      default: '0',
      required: true,
    },
    start: {
      type: [Number, String],
      default: '0',
    },
    formatValue: {
      type: Function,
      default: (value) => value,
    },
    easing: {
      type: String,
      default: 'linear',
    },
    duration: {
      type: Number,
      default: 1000,
    },
    update: Function,
    begin: Function,
    complete: Function,
    run: Function,
    delay: {
      type: Number,
      default: 0,
    },
    round: {
      default: null,
    },
  },
  data() {
    return {
      animatedValue: 0,
      fromValue: 0,
    };
  },
  created() {
    this.fromValue = this.start;
  },
  mounted() {
    this.animateValue(this.value);
  },
  watch: {
    value(value, prev) {
      this.fromValue = prev;
      this.animateValue(value);
    },
  },
  methods: {
    animateValue(value) {
      const { begin, easing, duration, complete, update, run, delay, round } = this;
      anime({
        targets: this,
        animatedValue: [this.fromValue, value],
        duration,
        easing,
        update,
        begin,
        complete,
        run,
        delay,
        round,
      });
    },
  },
};
</script>
